import { Box } from '@qcx/ui';

export interface BreadcrumbProps {
  children: React.ReactNode;
}

export const Breadcrumb = ({ children }: BreadcrumbProps) => (
  <Box as="nav" css={{ py: '$6' }}>
    <Box
      as="ol"
      css={{
        width: '80vw',
        listStyle: 'none',
        flexRowCenter: true,
        '> li + li': {
          '&:before': {
            content: '/',
            color: '$textMuted',
            d: 'inline-block',
            px: '$2',
            fontSize: '$xs'
          }
        },
        '@lg': {
          width: '100%'
        }
      }}
    >
      {children}
    </Box>
  </Box>
);
